import React from 'react'
import Cropper from 'react-easy-crop'
import styled from 'styled-components';

import Col from "antd/lib/col";
import Row from "antd/lib/row";
import Form from "antd/lib/form";
import Input from "antd/lib/input";
import Image from "antd/lib/image";
import Select from "antd/lib/select";
import Upload from "antd/lib/upload";
import Button from "antd/lib/button";
import Title from "antd/lib/typography/Title";
import { InboxOutlined } from '@ant-design/icons';

import getCroppedImg from "../utils/cropImage"

const { Dragger } = Upload;
const adTypes = [
  // {value: "banner", label: "Banner" },
  {value: "ribbon", label: "Listón" },
  {value: "popup", label: "Pop Up" }
]
const aspectRatios = {
  // 'banner': 320/480,
  'ribbon': 320/50,
  'popup': 336/336,
}

const AdvertisementForm = ({title, initialValues = {}, buttonText, submit, loading, setLoading}) => {
  // Form stuff
  const [form] = Form.useForm();
  const formRef = React.useRef();
  // cropper stuff
  const [zoom, setZoom] = React.useState(1)
  const selectedType = form.getFieldValue('type')
  const [crop, setCrop] = React.useState({ x: 0, y: 0 })
  const [cropImage, setCropImage] = React.useState(null)
  const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null)
  const onFileInput = (value) => setCropImage(value.file.originFileObj)
  
  const onCropComplete = React.useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }, [])

  const { image } = initialValues

  const preSubmit = async (values) => {
    setLoading(true)

    if (values.name === undefined) {
      values.name = ""
    }
    if (values.type === undefined) {
      values.type = "banner"
    }
    if (values.link === undefined) {
      values.link = ""
    }
    if (values.visibility === undefined) {
      values.visibility = true
    }
    
    let copy = {...values}
    if (typeof(values.image) === "object") {
      let croppedImage = await getCroppedImg(
        URL.createObjectURL(values.image.file.originFileObj),
        croppedAreaPixels,
        0
      )
      copy = {...copy, image: croppedImage}
    }
    
    console.log("inner", values)
    await submit(copy)
    setLoading(false)
  }
  
  return (
    <>
      <Row>
        <Col>
          <Title>{title}</Title>
        </Col>
      </Row>
      {
          image &&
          <Row style={{justifyContent: "center"}}>
              <Image src={image} height={200} />
          </Row>
      }
      <Row>
        <Col span={24}>
        <Form
            form={form}
            ref={formRef}
            layout='vertical'
            labelAlign="left"
            autoComplete="off"
            onFinish={preSubmit}
            initialValues={initialValues}
        >
            <Form.Item label="Nombre" name="name">
              <Input defaultValue={""} />
            </Form.Item>

            <Row gutter={24}>
                <Col span={12}>
                  <Form.Item label='Tipo' name='type'>
                      <Select defaultValue={"ribbon"} options={adTypes} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Visibilidad" name="visibility" valuePropName="active">
                      <Select defaultValue={{value: true, label: "Visible"}} options={[{value: false, label: "Oculto"},{value: true, label: "Visible"}]} />
                  </Form.Item>
                </Col>
            </Row>
            <Form.Item label="Enlace" name="link">
              <Input />
            </Form.Item>
            <Form.Item label='Imagen' name='image'>
                <Dragger onChange={onFileInput} maxCount={1} accept="image/*">
                <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                </p>
                <p className="ant-upload-text">Has click o arrastra la imagen a cargar</p>
                <p className="ant-upload-hint">
                    Solo acepta archivos de imágenes
                </p>
                </Dragger>
            </Form.Item>
              {
                cropImage && 
                <Form.Item>
                  <CropperContainer>
                    <Cropper
                    image={URL.createObjectURL(cropImage)}
                    crop={crop}
                    zoom={zoom}
                    aspect={aspectRatios[selectedType]}
                    onCropChange={setCrop}
                    onZoomChange={setZoom}
                    onCropComplete={onCropComplete}
                    />
                  </CropperContainer>
                </Form.Item>
              }
              <Form.Item>
                  <Button loading={loading} type="primary" block htmlType="submit">
                    {buttonText}
                  </Button>
              </Form.Item>
          </Form>
        </Col>
      </Row>
    </>
  )
}

export default AdvertisementForm

const CropperContainer = styled.div`
  height: 480px;
`